// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3zVvs","container":"styles_container__ZFKl2","title":"styles_title__ESt5q","wrapper":"styles_wrapper__1fb_I","answer":"styles_answer__enyNx"};